/**
 * Convert Western numerals (0-9) to Persian numerals (۰-۹)
 * @param {string|number} input - The input to convert
 * @returns {string} - String with Persian numerals
 */
export const toPersianDigits = (input) => {
  if (input === null || input === undefined) return '';

  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  return String(input).replace(/\d/g, (digit) => persianDigits[parseInt(digit)]);
};

/**
 * Convert Persian numerals (۰-۹) to Western numerals (0-9)
 * @param {string} input - The input to convert
 * @returns {string} - String with Western numerals
 */
export const toWesternDigits = (input) => {
  if (input === null || input === undefined) return '';

  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  return String(input).replace(/[۰-۹]/g, (digit) => persianDigits.indexOf(digit).toString());
};
